"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableIndexFromArray = void 0;
var getAvailableIndexFromArray = function (array, idx) {
    var availableItems;
    if (Array.isArray(array))
        availableItems = array;
    else
        availableItems = Object.values(array);
    if (idx < availableItems.length)
        return availableItems[idx];
    var coefOfDiff = Math.floor(idx / availableItems.length);
    return availableItems[idx - availableItems.length * coefOfDiff];
};
exports.getAvailableIndexFromArray = getAvailableIndexFromArray;
